import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { DevExNotificationComponent } from '../../../devExtreme/src/devExNotification/devExNotification.component';
import { ComponentStyle, IAbcComponent } from '../abcComponent.model';
import { AbcComponentService } from '../abcComponent.service';
import { INotification, NotificationStyle, ToastType } from './abcNotification';

@Component({
    selector: 'abcNotification',
    template: '<ng-template #abcNotification></ng-template>',
    standalone: false
})
export class AbcNotificationComponent implements IAbcComponent, OnInit, AfterViewInit, OnDestroy {
  @Input('id') attrId: string;
  @Input() message: string;
  @Input() closeOnOutsideClick: boolean;
  @Input() displayTime: number;
  @Input() type: ToastType;
  @Input() width: string;
  @Input() height: string | number;
  @Input() position: Object;
  @Input() animation: Object;
  @ViewChild('abcButton', { static: true, read: ViewContainerRef }) viewContainerRef: ViewContainerRef;
  private componentRef;
  private style: ComponentStyle;
  get id(): string {
    return this.componentRef.id;
  }
  private htmlAttributes: INotification;
  private eventListener = [];
  private subscription: Subscription;

  constructor(private abcComponentService: AbcComponentService) {
    this.style = ComponentStyle.DevExpress;
  }

  ngOnInit(): void {
    this.setButtonsAttributesIfAvailable();
    this.subscription = this.createComponentInstance().subscribe((component) => {
      this.eventListener.forEach((element) => {
        component.addEventListener(element.type, element.listener);
      });
    });
  }

  ngAfterViewInit(): void {
    this.abcComponentService.addInstance(this);
  }

  ngOnDestroy(): void {
    this.eventListener = [];
    this.abcComponentService.removeInstance(this);
    this.subscription.unsubscribe();
  }

  createComponentInstance(): Observable<any> {
    const observable = new Observable((observer) => {
      switch (this.style) {
        case ComponentStyle.DevExpress: {
          this.componentRef = this.abcComponentService.loadComponent(
            DevExNotificationComponent,
            this.viewContainerRef
          ).componentRef.instance;
          //do specific stuff for DevExpress
          break;
        }
      }

      if (this.htmlAttributes.id) this.componentRef.id = this.htmlAttributes.id;
      if (this.htmlAttributes.message) this.componentRef.message = this.htmlAttributes.message;
      if (this.htmlAttributes.closeOnOutsideClick)
        this.componentRef.closeOnOutsideClick = this.htmlAttributes.closeOnOutsideClick;
      if (this.htmlAttributes.type) this.componentRef.type = this.htmlAttributes.type;
      if (this.htmlAttributes.position) this.componentRef.position = this.htmlAttributes.position;
      if (this.htmlAttributes.animation) this.componentRef.animation = this.htmlAttributes.animation;
      if (this.htmlAttributes.displayTime) this.componentRef.displayTime = this.htmlAttributes.displayTime;
      if (this.htmlAttributes.setNotificationStyle) {
        const NotificationStyle: NotificationStyle = this.htmlAttributes.setNotificationStyle();
        this.componentRef.width = NotificationStyle.width;
        this.componentRef.height = NotificationStyle.height;
      }

      observer.next(this.componentRef);
    });

    return observable;
  }

  setCustomDataAttributes(dataAttr: Object): void {
    this.componentRef.setCustomDataAttributes(dataAttr);
  }

  addEventListener(
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions
  ): void {
    this.eventListener.push({ type, listener });
  }

  setButtonsAttributesIfAvailable(): void {
    if (this.attrId) {
      const style: NotificationStyle = {
        height: this.height ? this.height : 'auto',
        width: this.width ? this.width : 'auto',
      };
      this.htmlAttributes = {
        id: this.attrId,
        message: this.message,
        closeOnOutsideClick: this.closeOnOutsideClick,
        displayTime: this.displayTime,
        type: this.type,
        position: this.position,
        animation: this.animation,
        setNotificationStyle: (_notificationStyle) => (_notificationStyle = style),
      };
    }
  }
}
